import Navbar from '../components/navbar';
import Footer from '../components/footer';
import useAos from '../hooks/useAos';
import { PageMeta } from '../seo/PageMeta';
import { useTranslation } from 'react-i18next';

function NousJoindre() {
    const { t } = useTranslation(['pages', 'common']);

    return (
        <div className="flex items-stretch justify-around w-full pb-96 pt-128 px-64 overflow-hidden tablet-flex-column gap-32" data-navbar-theme="light">
            <div className="flex flex-column justify-center text-left w-50 self-stretch mobile-mb-16">
                <div className="overflow-hidden w-full">
                    <p className="text-title2 t-graymain fustat text-semibold mb-0 mt-16" data-aos="fade-up">{t('pages:contact.title')}</p>
                </div>
                <p className="text-subtitle t-blue outfit text-medium m-0" data-aos="fade-up" data-aos-delay="150">{t('pages:contact.subtitle')}</p>
            </div>
            <div className="flex flex-column bg-gray py-64 px-32 gap-32 nousjoindre-contact" data-navbar-theme="dark" data-aos="fade-up" data-aos-delay="300">
                <p className="text-subtitle t-white text-normal outfit m-0">{t('pages:contact.companyName')}</p>
                <div>
                    <p className="text-subtitle t-white text-regular outfit mb-8">{t('pages:contact.city')}</p>
                    <p className="text-subtitle2 t-white text-light outfit m-0">575 Rue Commerciale <br/> G9X 3A7</p>
                </div>
                <div>
                    <p className="text-subtitle t-white text-regular outfit mb-8">{t('common:labels.phone')}</p>
                    <a href="tel:8195236030" className="text-subtitle2 t-white text-light outfit m-0 text-link">819-523-6030</a>
                </div>
                <div>
                    <p className="text-subtitle t-white text-regular outfit mb-8">{t('common:labels.email')}</p>
                    <a href="mailto:info@groupedla.com" className="text-subtitle2 t-white text-light outfit m-0 text-link">info@groupedla.com</a>
                </div>
            </div>
        </div>
    );
}

export default function NousJoindrePage() {
    useAos();
    const { t } = useTranslation('pages');

    return (
        <>
            <PageMeta
                title={t('meta.contact.title')}
                description={t('meta.contact.description')}
                path="/nous-joindre"
            />
            <Navbar />
            <NousJoindre />
            <Footer />
        </>
    );
}
